var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnFilledBeanBagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3953 10.297L5.41139 10.2825L5.42642 10.2668C5.79117 9.88729 6.35634 9.25757 6.87839 8.58911C7.38461 7.94093 7.90843 7.18428 8.12301 6.56791C8.13758 6.52605 8.20227 6.4062 8.36908 6.22539C8.52667 6.05458 8.74602 5.86112 9.01914 5.66803C9.56657 5.28102 10.2945 4.92047 11.1033 4.74205C11.9082 4.5645 12.78 4.56964 13.6407 4.89197C14.4775 5.20537 15.3476 5.83483 16.1541 6.97443C16.3741 7.70706 17.1318 9.13675 18.7399 10.4626C19.6897 11.2458 20.2687 12.0173 20.49 12.9538C20.7083 13.8777 20.6018 15.0607 19.9795 16.718C19.6975 16.9859 19.2463 17.3677 18.724 17.7202C18.1302 18.1208 17.4974 18.4471 16.9469 18.5598C16.3442 18.6832 14.8742 18.7611 13.2113 18.8027C11.5838 18.8435 9.84471 18.8485 8.73427 18.8406C8.2428 18.8095 7.42708 18.6699 6.6173 18.351C5.79255 18.0262 5.04702 17.5444 4.61554 16.8771C3.99739 15.921 3.58992 14.8235 3.62739 13.7111C3.66416 12.6195 4.13101 11.4419 5.3953 10.297Z",
    stroke: "#0F172A",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1145 13.3132C16.0539 13.737 15.7084 14.2368 14.9595 14.6479C14.2191 15.0543 13.2169 15.2939 12.1521 15.2917C11.0871 15.2895 10.0884 15.0457 9.35365 14.6368C8.6107 14.2234 8.27253 13.7237 8.21709 13.3013",
    stroke: "#0F172A",
    strokeWidth: 1.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnFilledBeanBagIcon);
export default __webpack_public_path__ + "static/media/unFilledBeanBagIcon.38259fd960bdfc10f38acec22f767282.svg";
export { ForwardRef as ReactComponent };